// ==========================================================================
// Plyr states
// ==========================================================================

export const pip = {
    active: 'picture-in-picture',
    inactive: 'inline',
};

export default { pip };



// WEBPACK FOOTER //
// src/js/config/states.js